export enum OptInOptOutSource {
  ThankYouPage = 'ThankYouPage',
  Email = 'Email'
}
